// TODO: Use enums for keys and values 07.23.2024
export const NEW_TO_LEGACY_DELIVERY_METHOD_NAME: Record<string, string> = {
  COURIER_DELIVERY: 'JIFFY_DELIVERY',
  CLICK_AND_COLLECT: 'CLICK_AND_COLLECT',
};

// TODO: Use enums for keys and values 07.23.2024
export const NEW_TO_LEGACY_DELIVERY_MECHANIC_NAME: Record<string, string> = {
  ON_DEMAND: 'ON_DEMAND',
  SCHEDULED: 'SLOT',
  PICKUP: 'ON_DEMAND',
};

// TODO: Use enums for keys and values 07.23.2024
export const LEGACY_TO_NEW_DELIVERY_METHOD_NAME: Record<string, string> = {
  JIFFY_DELIVERY: 'COURIER_DELIVERY',
  CLICK_AND_COLLECT: 'CLICK_AND_COLLECT',
};
